import { AxiosResponse } from "axios";
import api from "../api";
import { Beneficiary } from "../types/beneficiaries";
import { formatDateForAPI } from "../utils/generalUtilities";

export const getAllBeneficiaries = async () => {
  return await api.get("/Utah/Application/Minors");
};

export const getAllBeneficiariesData = async (
  employeeid: string,
  useraccountid: string,
) => {
  return await api.get(
    `/Employee/EmployeeID/${employeeid}/UserAccountID/${useraccountid}`,
  );
};

export const getEnrolledBeneficiaries = async (employeeid: string) => {
  return await api.get(
    `/Account/investment-summary-benificiary-by-employee/${employeeid}`,
  );
};

export const getIndividualEnrolledBeneficiaryData = async (
  accountNumber: string,
) => {
  return await api.get(
    `/Account/investment-summary-by-benificiary/${accountNumber}`,
  );
};

export const getBeneficiaryMonthlyPerfoemance = async (
  userAccountID: number,
  minorAccountID: number,
) => {
  return await api.get(
    `/Account/support/getmonthlyperformance/${userAccountID}/${minorAccountID}`,
  );
};

export const createBeneficiaries = async (
  beneficiaries: Beneficiary[],
  auth: { userAccountID: string },
): Promise<AxiosResponse<any, any>> => {
  if (!beneficiaries || !auth || !auth.userAccountID) {
    throw new Error("createBeneficiaries: Missing required parameters");
  }

  const formattedBeneficiaries = beneficiaries.map((beneficiary) => ({
    userAccountID: auth.userAccountID,
    parentUserAccountID: auth.userAccountID,
    firstName: beneficiary.firstName ?? "",
    middleName: beneficiary.middleName ?? "",
    lastName: beneficiary.lastName ?? "",
    dateOfBirth: formatDateForAPI(beneficiary.dateOfBirth ?? ""),
    relationship: beneficiary.relationship ?? "",
    changeReason: "Adding child",
  }));

  return await api.post("/Employee/Minors", formattedBeneficiaries);
};

export const updateBeneficiaries = async (
  beneficiaries: Beneficiary[],
  auth: { userAccountID: string },
): Promise<AxiosResponse<any, any>> => {
  if (!beneficiaries || !auth || !auth.userAccountID) {
    throw new Error("updateBeneficiaries: Missing required parameters");
  }

  const formattedBeneficiaries = beneficiaries.map((beneficiary) => ({
    minorAccountID: beneficiary.id,
    userAccountID: auth.userAccountID,
    parentUserAccountID: auth.userAccountID,
    firstName: beneficiary.firstName,
    middleName: beneficiary.middleName ?? "",
    lastName: beneficiary.lastName,
    dateOfBirth: formatDateForAPI(beneficiary.dateOfBirth),
    relationship: beneficiary.relationship,
    changeReason: "Updating child",
  }));

  return await api.put("/Employee/Minors", formattedBeneficiaries);
};

export const removeBeneficiary = async (
  minorAccountID: string,
  auth: { userAccountID: string },
): Promise<AxiosResponse<any, any>> => {
  if (!minorAccountID || !auth || !auth.userAccountID) {
    throw new Error("removeBeneficiary: Missing required parameters");
  }

  return await api.delete(
    `/MinorAccount/${minorAccountID}/${auth.userAccountID}`,
  );
};

export const fetchEmployeeData = async () => {
  /* return await api.get(
    `/Employee/EmployeeID/${employeeID}/UserAccountID/${userAccountID}`
  ); */
  return await api.get(`/MinorAccount`);
};
